<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header"><h3>가입내역</h3></div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              단말기 모델명
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  <span>{{ registration.dvicMdlNm }}</span>
                  <span class="field-group-space"> </span>
                  <span>({{ registration.dvicMdlCd }})</span>
                </p>
              </div>
            </dd>
          </dl>
          <!--[ST] RITM2876892 M2M 요금약정기간 추가 건 -->
          <div v-if="this.openMarketInfo.mblSvcDivsCd != 'LZP0002200'">
            <dl class="field-group">
              <dt class="field-label">
                단말기 색상
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    {{ registration.hphnColrNm }}
                  </p>
                </div>
              </dd>
            </dl>

            <dl class="field-group" v-if="
                openMarketInfo.registrationTypeCode === 'chg' ||
                  openMarketInfo.registrationTypeCode === 'renew'
              ">
              <dt class="field-label">
                휴대폰번호
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    <span>{{ chgHopTlno }}</span>
                  </p>
                </div>
              </dd>
            </dl>
            <dl class="field-group" v-if="openMarketInfo.registrationTypeCode === 'new'">
              <dt class="field-label">
                희망번호
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    <span v-if="openMarketInfo.rotrRqstCd !== 'Y'"
                      >010-****-</span
                    >
                    <!-- 라우터일 경우에는 무조건 4자리만 받는다 -->
                    <span>{{ registration.chgHopTlno }}</span>
                  </p>
                </div>
              </dd>
            </dl>
            
            <dl class="field-group" v-if="openMarketInfo.crgrSaleYn === 'Y'">
              <dt class="field-label">
                충전기선택
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">
                    <!--              비구매시-->
                    <span v-if="registration.crgrBuyYn === 'N'"
                      >금액 : 11,000원 / 비구매</span
                    >
                    <!--              구매시-->
                    <span
                      v-if="registration.crgrBuyYn === 'Y'"
                      class="field-group-space"
                    >
                      금액: 11,000 / 구매(청구서납부)
                    </span>
                  </p>
                </div>
              </dd>
            </dl>
            <!--         판매금액-->
            <dl
              class="field-group"
              v-if="
                'N' === openMarketInfo.isttYn &&
                  openMarketInfo.rcmdSaleKcCd &&
                  'P' !== openMarketInfo.rcmdSaleKcCd
              "
            >
              <dt class="field-label">
                판매금액
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <p class="data-text">{{ openMarketInfo.isttAmt }}원</p>
                </div>
              </dd>
            </dl>
          </div>
          <!--[ED] RITM2876892 M2M 요금약정기간 추가 건 -->
          <!--          <dl class='field-group'>-->
          <!--            <dt class='field-label'>-->
          <!--                휴대폰번호  -->
          <!--            </dt>-->
          <!--            <dd class='field-control'>-->
          <!--             <div class='field-control-sub'>-->
          <!--              <p class='data-text'>{{step2.device.mobilePhoneNo}}</p> -->
          <!--             </div>-->
          <!--            </dd>-->
          <!--          </dl>-->

          <!--          <dl class='field-group'>-->
          <!--            <dt class='field-label'>-->
          <!--                iPhone 이용고객 동의  -->
          <!--            </dt>-->
          <!--            <dd class='field-control'>-->
          <!--              <div class='field-control-sub'>-->
          <!--                <p class='data-text'>{{step2.device.agreeIPhone}}</p> -->
          <!--              </div>-->
          <!--            </dd>-->
          <!--          </dl>-->

          <!--          <dl class='field-group'>-->
          <!--            <dt class='field-label'>-->
          <!--              5G 개통고객 대상 안내 -->
          <!--            </dt>-->
          <!--            <dd class='field-control'>-->
          <!--              <div class='field-control-sub'>-->
          <!--                <p class='data-text'>{{step2.device.agree5G}}</p>-->
          <!--              </div>-->
          <!--            </dd>-->
          <!--          </dl>-->
        </div>
      </div>
      <div class="section"  v-if="registration.ppNm">
        <div class="section-header">
          <h3>신청내역</h3>
        </div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              요금제
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">{{ registration.ppNm }}</p>
                <a
                  id="popFeeDesc"
                  @click="feeDesc"
                  title="새창열림"
                  target="_blank"
                  class="link-detail"
                  >상세보기</a
                >
              </div>
            </dd>
          </dl>
          <dl class="field-group" v-if="registration.mobileRegistrationCaptureDetail.g5CovrWideCtdoNm">
            <dt class="field-label">
              5G 커버리지
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">{{ registration.mobileRegistrationCaptureDetail.g5CovrWideCtdoNm }} {{ registration.mobileRegistrationCaptureDetail.g5CovrCcwNm }} {{ registration.mobileRegistrationCaptureDetail.g5CovrTownNm }}</p>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'
export default {
  name: 'RegistrationStep2SectionDevice',

  props: {
    registrationProps: Object,
    openMarketInfoProps: Object
  },

  data() {
    return {
      registration: {},
      openMarketInfo: {},
      chgHopTlno: '',
    }
  },

  mounted() {
    this.registration = this.registrationProps
    this.openMarketInfo = this.openMarketInfoProps
    if(this.openMarketInfo.registrationTypeCode === 'chg' ||
      this.openMarketInfo.registrationTypeCode === 'renew') {
      this.chgHopTlno = this.formatPhoneNumber(this.registration.chgHopTlno)
    }
    this.registration.hphnColrNm = this.registration.dvicColrCd === "" ? "색상없음" : this.registration.hphnColrNm
  },

  computed: {},

  methods: {
    /** 
     * Function    : feeDesc
     * Description : 요금제 정보 상세보기
     **/
    //[ST] RITM2876892 M2M 요금약정기간 추가 건
    feeDesc(e) {
      e.preventDefault()

      if( this.openMarketInfo.mblSvcDivsCd === 'LZP0002200'){
        window.open(
        'https://www.lguplus.com/biz/all/telecom/wireless/mobile-internet/B000000131',
        'PopupWin',
        'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
        )
      }else{
        window.open(
        'https://www.lguplus.com/plan/mplan',
        'PopupWin',
        'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
        )
      }
    },
    //[ED] RITM2876892 M2M 요금약정기간 추가 건

    /** 
     * Function    : formatPhoneNumber
     * Description : 휴대폰 번호 formatting
     **/
    formatPhoneNumber(phoneNum) {
      if (phoneNum.length === 10) {
        return (
          phoneNum.substring(0, 3) +
          '-' +
          phoneNum.substring(3, 6) +
          '-' +
          phoneNum.substring(6, 10)
        )
      } else {
        return (
          phoneNum.substring(0, 3) +
          '-' +
          phoneNum.substring(3, 7) +
          '-' +
          phoneNum.substring(7, 11)
        )
      }
    }
  }
}
</script>

<style scoped></style>
